export default "__VITE_ASSET__dnoXXpM4__"